var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['managing-box', { 'managing-box--x-scroll': _vm.xScroll }]},[(_vm.title)?_c('header',{staticClass:"box__header"},[_c('span',{class:[
				'box__header__title',
				{
					'box__header__title--required': _vm.isRequired,
				},
			],domProps:{"innerHTML":_vm._s(_vm.title)}})]):_vm._e(),_c('div',{class:[
			'box__conts',
			_vm.contsClass,
			{
				'box__conts--no-padding': _vm.noPadding,
				'box__conts--block': _vm.isBlockBox,
				'box__conts--horizontal': _vm.horizontalMode,
			},
		],style:({
			padding: _vm.contsPadding,
			height: _vm.contsHeight,
		})},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }